import { useState } from 'react';

import { validators } from '@/shared/utils/validator';

import { ValidationParams } from '../types/OrderTypes';

export const useValidateOrder = () => {
  const [errors, setErrors] = useState({
    businessRegistrationNumber: '',
    companyName: '',
    receiverName: '',
    companyEmail: '',
    phoneNumber: '',
    addressDetail: '',
  });

  const validateOrder = (params: ValidationParams) => {
    const { receiverInfo, businessRegistrationNumber } = params;

    const newErrors: typeof errors = {
      businessRegistrationNumber: '',
      companyName: '',
      receiverName: '',
      companyEmail: '',
      addressDetail: '',
      phoneNumber: '',
    };

    // Business registration number
    const businessRegistrationValidation =
      validators.businessRegistrationNumber(businessRegistrationNumber);
    if (!businessRegistrationValidation.valid) {
      newErrors.businessRegistrationNumber =
        businessRegistrationValidation.error;
    }

    // Company Name
    const companyNameValidation = validators.companyName(
      receiverInfo.companyName,
    );
    if (!companyNameValidation.valid) {
      newErrors.companyName = companyNameValidation.error;
    }

    // Receiver Name
    const receiverNameValidation = validators.receiverName(
      receiverInfo.receiverName,
    );
    if (!receiverNameValidation.valid) {
      newErrors.receiverName = receiverNameValidation.error;
    }

    // Receiver email
    const companyEmailValidation = validators.email(receiverInfo.companyEmail);
    if (!companyEmailValidation.valid) {
      newErrors.companyEmail = companyEmailValidation.error;
    }

    // Phone number
    const phoneNumberValidation = validators.phoneNumber(
      receiverInfo.phoneNumber,
    );
    if (!phoneNumberValidation.valid) {
      newErrors.phoneNumber = phoneNumberValidation.error;
    }

    // Address
    const addressDetailValidation = validators.address(
      receiverInfo.addressDetail,
    );
    if (!addressDetailValidation.valid) {
      newErrors.addressDetail = addressDetailValidation.error;
    }

    setErrors(newErrors);

    return Object.values(newErrors).every(
      (errorMessage) => errorMessage === '',
    );
  };

  return { validateOrder, errors };
};
